import { EventTypes } from '../lib/constants';
import withPusher from './withPusher';
import config from '@/config';

export default {
	mixins: [withPusher],

	computed: {
		shopifyProductsSyncChannelName() {
			return `account.${config.hpStoreAccountID}.products.shopify.sync`;
		}
	},

	mounted() {
		if (!config.hpStoreAccountID) return;
		this.initializePusherSubscribers();
	},

	beforeDestroy() {
		if (!this.pusherClient) return;
		this.pusherClient.unsubscribe(this.shopifyProductsSyncChannelName);
	},

	methods: {
		shopifyProductSyncCompleteHandler(message) {
			const { productName } = _.get(message, 'data', {});
			if (!productName) return;

			this.$notify({
				type: 'success',
				title: this.$t('Shopify Product Sync Completed'),
				text: this.$t(
					`You product (${productName}) has been successfully synced with Shopify. Please reload the page to see the latest changes.`
				)
			});
		},

		initializePusherSubscribers() {
			try {
				const existingChannels = this.pusherClient.getChannels();
				const existingShopifyProductSyncChannel = _.find(existingChannels, [
					'name',
					this.shopifyProductsSyncChannelName
				]);
				if (existingShopifyProductSyncChannel) return;

				this.pusherClient.subscribe(
					this.shopifyProductsSyncChannelName,
					EventTypes.ShopifyProductSyncComplete,
					this.shopifyProductSyncCompleteHandler
				);
			} catch (error) {
				this.$notify({
					type: 'error',
					title: this.$t('Error'),
					text: this.$t('Error while initializing shopify product sync subscriber')
				});
			}
		}
	}
};
